import request from '../utils/request'

// 常用过敏史

export function getAllergy(query) {
    return request({
        url: "patient/patientinfo/getAllergy",
        method: "post",
        data: query,
    }).then(res => res.data)
}
// 模糊搜索诊断集合
export function diagnostics(query) {
    return request({
        url: "patient/prescription/diagnosticsV2",
        method: "post",
        data: query,
    }).then(res => res.data)
}
// 获取常用诊断集合
export function diagnosticsHot(query) {
    return request({
        url: "patient/prescription/diagnosticsHot",
        method: "post",
        data: query,
    }).then(res => res.data)
}
// 获取常用诊断集合 （新）
export function diagnosticsHotV2(query) {
    return request({
        url: "patient/prescription/diagnosticsHotByType",
        method: "post",
        data: query,
    }).then(res => res.data)
}
// 校验是否已经开通远程处方服务
export function checkIfOpen(data) {
    return request({
        url: '/patient/drugstore/checkIfOpenRemoteService',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 测试
export function test(data) {
    return request({
        url: '/test',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// *保存或者修改患者信息
export function savePatient(data) {
    return request({
        url: '/patient/patientinfo/saveOrUpdatePatientInfo',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 查询/保存患者信息
export function searchPatientInfo(data) {
    return request({
        url: '/patient/patientinfo/queryPatientInfoPage',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
// 首页获取未读消息总数
export function getNoreadMessage(data) {
    return request({
        url: '/patient/systemmessage/queryNotReadTotalMessage',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 获取消息列表
export function getMessageList(data) {
    return request({
        url: '/patient/systemmessage/queryMessagePage',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
// 将消息列表置为已读
export function getMessageListReaded(data) {
    return request({
        url: '/patient/systemmessage/signMessageState',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
// 查询处方列表
export function getPreList(data) {
    return request({
        url: '/patient/prescription/queryInquiryPrescriptionPage',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
// 根据处方guid查询处方详情
export function getPreDetail(data) {
    return request({
        url: '/patient/prescription/getInquiryPrescriptionByGuid',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
// 根据处方guid查询处方详情
export function getPreDetail2(data) {
    return request({
        url: '/patient/prescription/getInquiryPrescriptionByParam',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
// 根据app弹出的 guid查询消息详情：此guid和查询处方的guid不是同一个！
// 用app弹出的guid，来查询此接口、请求出message_guid,meaaage_type==1时，用此message_guid去查询处方详情
export function getPreGuid(data) {
    return request({
        url: '/patient/systemmessage/getSystemMessageByGuid',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}

// 登录
export function toLogin(data) {
    return request({
        url: '/drugstore/login',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}

// 登出
export function logOut(data) {
    return request({
        url: '/drugstore/logout',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}

// 查询用户信息
export function getEmployeeInfo(data) {
    return request({
        url: '/drugstore/queryEmployeeById',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}

// 修改密码
export function updatePassword(data) {
    return request({
        url: '/drugstore/updateEmployeePasswordByEmployeeId',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}

// 获取常用病情描述
export function getMainSuitList(data) {
    return request({
        url: '/patient/patientinfo/getCommonSuit',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
// 问诊信息表单提交
export function patientInfoAndGotoInquir(data) {
    return request({
        url: '/patient/inquiryorder/patientCustomInfoAndGotoInquiry',
        method: 'post',
        data: data
    }).then(res => res.data.result)
}
export function goInquiry(data) {
    return request({
        url: '/patient/inquiryorder/gotoInquiry',
        method: 'post',
        data: data
    }).then(res => res.data)
}
// 拉取参数 roomNumber。。。
export function getPatientInfo() {
    return request({
        url: '/physician/inquiry/getInquiryingPatientInfoByPhysicianId',
        method: 'post'
    })
}
// 轮询去问诊
export function getWaitingDetail(data) {
    return request({
        url: '/patient/inquiryorder/getWaitingDetail',
        method: 'post',
        ctrToast: true,
        data
    })
}
// 获取医生在线状态
export function physicanStatus(data) {
    return request({
        url: '/patient/drugstore/getDoctorOnlineState',
        method: 'post',
        data
    })
}
// 金牌医生接口
export function getGoldPhysicans(data) {
    return request({
        url: '/patient/patientinfo/getGoldDoctor',
        method: 'post',
        data
    })
}
// 查询患者信息
export function realTimeSearchPatient(data) {
    return request({
        url: '/patient/patientinfo/realTimeSearchPatient',
        method: 'post',
        data: data
    })
}

// 精确搜，极速
export function drugsList(data) {
    return request({
        url: '/patient/drugstore/getProductsByNameAndSpec',
        method: 'post',
        data
    })
}
// 精确搜，非极速
export function drugsList2(data) {
    return request({
        url: '/patient/drugstore/getProductsByNameAndSpecV2',
        method: 'post',
        data
    })
}
// 模糊搜，极速
export function queryMedicineList(data) {
    return request({
        url: '/patient/drugstore/getSuggestNamesByProductsName',
        method: 'post',
        data
    })
}
// 模糊搜索，非极速问诊
export function queryMedicineList2(data) {
    return request({
        url: '/patient/drugstore/getSuggestNamesByProductsNameV2',
        method: 'post',
        data
    })
}
// 获取药品使用单位
export function unitList() {
    return request({
        url: '/medicinal/dict/unit',
        method: 'post'
    })
}
// 获取药品使用频次
export function rateList() {
    return request({
        url: '/medicinal/dict/rate',
        method: 'POST'
    })
}

// 获取药品用量
export function getDose() {
    return request({
        url: '/medicinal/dict/dose',
        method: 'POST'
    })
}

// 获取药品使用方法
export function getMethod() {
    return request({
        url: '/medicinal/dict/usage',
        method: 'POST'
    })
}
// 新增药品
export function addMedicine(data) {
    return request({
        url: '/patient/drugstore/addProductForDrugstore',
        method: 'POST',
        data
    })
}
// 修改用法用量
export function updateMedicine(data) {
    return request({
        url: '/patient/drugstore/updateProductUsageAndDosage',
        method: 'POST',
        data
    })
}
/**
 * @description: 上传性能日志
 * @param {Array} <Object>List
 * [{
    "timestamp": 1585281085090, // 当前毫秒时间戳
    "time": "2020-03-31 11:05:02",
    "userId": 666, // 账号ID
    "phone": "16800012301", //手机号
    "appInfo": {
        "appName": "doctor-android",
        "appVersion": "1.1.0",
        "osType": "", // android, ios
        "osVersion": "",
        "brand": "",
        "model": "",
    }
    "msg": "医生接诊成功",
    "msgCode": "200",//日志类型
    "ext": ""
}]
 */
export function sendLog(query) {
    return request({
        url: 'log/upload',
        method: 'post',
        data: query
    })
}
//获取top5药品
export function suggestMedicine(data) {
    return request({
        url: '/patient/drugstore/getHotProducts',
        method: 'POST',
        data
    }).then(res => res.data)
}

/**
 * desc 提交评价接口
 * @param {String} bizId 处方单ID
 * @param {String} drugstoreId 门店ID
 * @param {Integer} star 星星等级，1，2，3，4，5
 * @returns {type} 返回值描述
 */
export function saveRatingStar(data) {
    return request({
        url: '/patient/ratingstar/saveRatingStar',
        method: 'POST',
        data
    }).then(res => res.data)
}
/**
 * @description:根据条形码获取药品
 * @param {String} barcode 条形码
 * @param {String} organSign 机构号
 * @return: 
 */
export function getMedicineByBarcode(data) {
    return request({
        url: '/patient/drugstore/getMedicineByBarcode',
        method: 'POST',
        data
    }).then(res => res.data)
}

export function getMedicineByBarcodeNew(data) {
    return request({
        url: '/patient/drugstore/getMedicinesByBarcode',
        method: 'POST',
        data
    }).then(res => res.data)
}

export function queryDrugstorePackageInquiryType(data) {
    return request({
        url: '/patient/inquiryorder/queryDrugstorePackageInquiryType',
        method: 'POST',
        data
    }).then(res => res.data)
}

export function getDiagnoseByMedicine(data) {
    return request({
        url: '/patient/patientinfo/getDiagnostics',
        method: 'POST',
        data
    }).then(res => res.data)
}
export function getBanner(data) {
    return request({
        url: "/advertisementConfig/queryAD",
        method: "post",
        data: data
    }).then(res => res.data);
}
// 中药参数配置查询(用法、加工方式)
export function chineseHerbology(data) {
    return request({
        url: "/medicinal/dict/chineseHerbology",
        method: "POST",
        data,
    });
}
// 根据门店organSign获取问诊规则
export function getInquiryAreaRuleByOrganSign(data) {
    return request({
        url: "/patient/inquiry/area/rule/getInquiryAreaRuleByOrganSign",
        method: "POST",
        data,
    });
}
// 根据门店organSign获取问诊规则
export function checkBtermInquiryPermission(data) {
    return request({
        url: "/patient/drugstore/checkBtermInquiryPermission",
        method: "POST",
        data,
    });
}

// 判断是否走图文交互优化流程
export function judgeImageText(data) {
    return request({
        // url: "/patient/inquiryorder/getTeletextInquiryInteractionOptimizeSwitch",
        url: "/patient/inquiryorder/getInquiryAreaAndDrugstoreConfigSwitch",
        method: "POST",
        data,
    });
}
// 用法用量编辑
export function getUsageAndDosageWriteSwitch(data) {
    return request({
        url: "/common/entrance/getUsageAndDosageWriteSwitch",
        method: "GET",
        data,
    });
}
// 临时展示用法用量
export function getInquiryAreaAndDrugstoreConfigSwitch(data) {
    return request({
        url: "/common/entrance/getInquiryAreaAndDrugstoreConfigSwitch",
        method: "GET",
        data,
    });
}
// 根据门店organSign获取问诊规则
export function uploadFile(data) {
    var formData = new FormData();
    formData.append("file", data.file);
    return request({
        url: "/file/upload",
        method: "POST",
        data: formData,
    })
}

// 获取离店限制配置
export function disLimitGet(data) {
    return request({
        url: "/inquiry/distanceLimit/getConfig",
        method: "POST",
        data,
    });
}

// 获取离店限制配置
export function disLimitUpdate(data) {
    return request({
        url: "/inquiry/distanceLimit/updateConfig",
        method: "POST",
        data,
    });
}

// 查询是否走图文问诊优化
export function checkInquiryConfig(data){
    return request({
        // url: "/patient/inquiryorder/getInquiryAreaAndDrugstoreConfigSwitch",
        url: "/common/entrance/getInquiryAreaAndDrugstoreConfigSwitch",
        method: "GET",
        data,
    });
}

// 查询图文问诊IM对话数据
export function getInquiryInteractiveMessage(data){
    return request({
        url: "/physician/inquiry/getTeletextInquiryInteractiveMessage",
        method: "POST",
        data,
    });
}

// 获取中西药带出药品开关
export function getDrugstoreDrugSwitch(data) {
    return request({
        url: "/patient/drugstoreConfig/checkAuthority",
        method: "POST",
        data,
    });
}

// 修改患者是否展示
export function postUpdateIsNotShowStatus(data) {
    return request({
        url: "/patient/patientinfo/updateIsNotShowStatus",
        method: "POST",
        data,
    });
}

// 获取包装单位
export function postPackUnitList(data) {
    return request({
        url: "/medicinal/dict/custom/unit",
        method: "POST",
        data,
    });
}

// 查询App 新手教程列表
export function getNewCourse(data) {
    return request({
        url: "/drugstore/queryBeginnerTutorial",
        method: "POST",
        data,
    });
}










// 获取药品审查列表
export function getPageConfigurationQueryRuleByDrug(data) {
    return request({
        url: "/usageAndDosage/review/queryRuleByDrug",
        method: "POST",
        data,
    });
}

// 是否展示预购药品
export function checkOrganSignSwitch(data) {
  let url = `/common/entrance/checkOrganSignSwitch?organSign=${data.organSign}&businessType=11`
  return request({
      url: url,
      method: 'get',
  })
}

// 获取统筹类型列表
export function getOverallPlanTypeList(organSign) {
    return request({
        url: "/common/entrance/queryDrugStoreOverallPlanType",
        method: "POST",
        data: {
            organSign
        }
    })
}
    